<template>
  <modal :name="name" @before-open="beforeOpen" @opened="afterOpen" width="400px" height="220px">
    <div class="modal-create-new-container">
      <div class="modal-title">
          <span>{{$t(`create_${type}_description`)}}
            <template v-if="type != 'project'"> in project:<div class="project-name">{{parentProject && parentProject.name}}</div></template>
          </span>
          <div class="close" @click="closeModal"></div>
        </div>
      <div class="main-row">
        <div class="input-container">
          <input class="project-title" ref="mainInput" type="text" :placeholder="$t(`new_${type}_default_name`)" v-model="newName" v-on:keyup.enter="createNew" />
        </div>
      </div>
      <div class="main-row" v-if="type == 'project'" >
        <div class="input-container pickers">
          <select class="input-select" ref="mainInput" v-model="newScenario">
            <option selected="selected" value="cardiosafe">ITQT - Cardiotoxicity</option>
            <option disabled value="CRT">CRT - Cardiac Resynchronization Therapy</option>
            <option disabled value="VAD">VAD - Ventricular Assist Device</option>
          </select>
        </div>
      </div>
      <div class="low-row">
        <div class="btn btn--secondary btn--ghost" @click="createNew">{{$t(`create_${type}`)}}</div>
      </div>
    </div>
  </modal>
</template>

<script>
import Api from '@/api'
import {createEmptyTrial, createEmptyProject} from '@/utils/ConfigUtils'
export default {
  name: 'ModalCreateNew',
  props: ['name', 'scenario','type','parentProject'],
  data() {
    return {
      newName: '',
      newScenario: '',
      // fieldValues: {},
      srcTrial: null
    }
  },
  computed: {
  },
  asyncComputed: {
  },
  methods: {
    beforeOpen(event) {
      this.newName = ''
      this.newScenario = 'cardiosafe'
      if(event.params && event.params.trial) {
        this.srcTrial = event.params.trial
        this.newName = this.$t("copy_of")+' ' +this.srcTrial.name
      }
    },
    afterOpen(){
      this.$refs.mainInput.focus()
    },
    closeModal(){
      this.$modal.hide(this.name)
    },
    createNew(){
      if(this.type==='project') this.createNewProject()
      else if(this.type==='trial') this.createNewTrial()
      else if(this.type==='trial_duplicate') this.createDuplicateTrial(this.srcTrial)
    },
    createNewTrial(){
      createEmptyTrial(this.newName, this.parentProject).then((trial)=>{
        Api.postTrial(trial).then(res => {
          this.$router.push(`/project/${this.parentProject.id}/trial/${res.id}`)
        })
      })
    },
    createDuplicateTrial(srcTrial){
      let newTrial = {...srcTrial}
      newTrial.name = this.newName
      newTrial.status = "draft"
      delete newTrial.id
      Api.postTrial(newTrial).then(res => {
        this.$router.push(`/project/${res.projectId}/trial/${res.id}`)
      })
    },
    createNewProject () {
      // let fields = this.projectFields
      // let projectObject = createEmptyProject(this.newName)
      console.log('creating new project ' + this.newName + ' with scenario: ' + this.newScenario)
      createEmptyProject(this.newName, this.newScenario).then(proj => {
        //OK response -> Go to new new project ID
        return Api.postProject(proj).then((res)=>{
          return this.$router.push(`/project/${res.id}`)
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.modal-create-new-container
  display: flex
  flex-direction: column
  height: 100%
  padding: 25px
  width: 100%
  .project-name
    font-weight $fw-bold
  .modal-title
    color: $cloud-burst
    m-font-size(18,22)
    margin-bottom: 20px
    display flex
    position relative
    .close
      cursor: pointer
      height: 25px
      m-icon("cross", 25)
      position: absolute
      right: 0
      top: 50%
      transform: translateY(-50%)
      width: @height

  .main-row
    align-items: center
    display: flex
    margin-bottom: 20px
    position: relative
    width: 100%

    .input-container
      height: 48px
      width: 100%
      border-radius 4px
      border: 1px solid $heather
      padding 4px
    input
      background: none
      border none
      font-weight: $fw-medium
      m-font-size(22, 32)
      outline: none
      &::placeholder
        color: $spun-pearl
        // font-style: italic

  .low-row
    .description
      color: $trout
      margin-bottom: 20px


.pickers
  display: flex
  flex-direction column
  div
    cursor pointer
    white-space nowrap
    &:hover
      text-decoration underline

.input-select
  background: none
  border none
  m-font-size(20)
  outline: none
  &::placeholder
    color: $spun-pearl
    // font-style: italic
  
  option
    m-font-size(15)
</style>
